import React, { useState } from 'react';
import '../UserDetailsForm.css'; // Import the CSS file


const baseURL = process.env.BASE_URL || "";

const UserDetailsForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    gender: '',
    
    phoneNumber: '',
    email:'',
    bloodGroup:'',
    guardianName:'',
    guardianNumber:''
  });
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const response = await fetch(`${baseURL}/api/formrouter/visit/hospital`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      const result = await response.json();
      console.log('Server Response:', result);
      alert('Form submitted successfully!');
      
      // Optional: Reset the form after submission
      setFormData({
        name: '',
        age: '',
        gender: '',
        phoneNumber: '',
        email: '',
        bloodGroup: '',
        guardianName: '',
        guardianNumber: '',
      });

    } else {
      console.error('Failed to submit form:', response.status);
      alert('Submission failed.');
    }
  } catch (error) {
    console.error('Error:', error);
    alert('An error occurred while submitting the form.');
  }
};


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  

  return (
    <div className="form-container">
      <h2 className='title'>HOSPITAL</h2>
      <form onSubmit={handleSubmit} className="user-form">
        <input type="text" name="name" placeholder="Full Name" value={formData.name} onChange={handleChange} required />
        <input type="number" name="age" placeholder="Age" value={formData.age} onChange={handleChange} required />
        <select name="gender" value={formData.gender} onChange={handleChange} required>
          <option value="">Select Gender</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
          <option value="Other">Other</option>
        </select>
        
        <input type="tel" name="phoneNumber" placeholder="Phone Number" value={formData.phoneNumber} onChange={handleChange} required />
        <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
        <input type="text" name="bloodGroup" placeholder="Blood group" value={formData.bloodGroup} onChange={handleChange} required />
        <input type="text" name="guardianName" placeholder="Guardian's Name" value={formData.guardianName} onChange={handleChange} required />
        <input type="tel" name="guardianNumber" placeholder="Guardian's phone number" value={formData.guardianNumber} onChange={handleChange} required />
        

        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default UserDetailsForm;
//UserDetailsFom.js